import type { AlpineComponent } from 'alpinejs'
import { ConsentManager } from '@/js/modules/consent-manager'

export type ConsentManagerUiOptions = {
  labels?: Record<string, string>
}

export default (consentManager: unknown) => {
  if (!(consentManager instanceof ConsentManager)) {
    if (DEV_MODE) console.warn('consentManager is not a ConsentManager instance')
    return {}
  }

  const x = consentManager.state.config.ui.alpine.prefix

  return {
    dismissed: false,
    barOpen: false,
    managerOpen: false,
    movedFocus: false,

    init(this) {
      window.addEventListener('hashchange', () => this.shouldOpen())
      window.addEventListener('popstate', () => this.shouldOpen())

      this.dismissed = this.isDismissed()
      this.barOpen = !this.dismissed

      this.shouldOpen()
      consentManager.ui = this
    },

    openBar() {
      this.barOpen = true
    },

    closeBar() {
      this.barOpen = false
    },

    openManager() {
      this.managerOpen = true
      this.movedFocus = false
      this.closeBar()

      let url = new URL(window.location.href)
      if (url.hash !== '#consent-manager') {
        url.hash = 'consent-manager'
        history.pushState(null, '', url)
      }
    },
    closeManager() {
      this.managerOpen = false

      let url = new URL(window.location.href)

      if (url.hash === '#consent-manager') {
        url.hash = ''
        history.pushState(null, '', url)
      }

      if (!this.dismissed) {
        this.openBar()
      }
    },

    close() {
      this.closeBar()
      this.closeManager()
    },

    dismiss() {
      this.dismissed = true
      localStorage.setItem(
        'consent-manager-dismissed',
        JSON.stringify(consentManager.getServiceVersions()),
      )
    },

    isDismissed() {
      let dismissedServiceVersions = localStorage.getItem('consent-manager-dismissed')
      if (!dismissedServiceVersions) return false

      let currentServiceVersions = JSON.stringify(consentManager.getServiceVersions())
      return dismissedServiceVersions === currentServiceVersions
    },

    giveAllAndDismiss() {
      consentManager.giveAllConsents()
      this.dismiss()
      this.close()
    },

    revokeAllAndDismiss() {
      consentManager.revokeAllConsents()
      this.dismiss()
      this.close()
    },

    shouldOpen(this: AlpineComponent<any>) {
      // check if hash is "consent-manager"
      if (window.location.hash === '#consent-manager') {
        this.managerOpen = true
        this.barOpen = false

        // When the focus is moved initially, mark "movedFocus" as false to not show the outline
        this.$el.addEventListener(
          'focusin',
          () => {
            this.movedFocus = false
          },
          { once: true },
        )
      } else {
        this.managerOpen = false
      }
    },

    overlay: {
      [`${x}-bind:class`](this: AlpineComponent<any>) {
        return {
          'cm-active': this.managerOpen,
        }
      },
    },

    bar: {
      [`${x}-bind:class`](this: AlpineComponent<any>) {
        return {
          'cm-active': this.barOpen,
        }
      },
    },
  }
}
